import { useQuery } from '@apollo/client';
import { Box } from '@material-ui/core';
import { useMemo, useState } from 'react';
import styles from './wardrobe-section.module.scss';
import { PATH } from 'routes/constant';
import { useHistory } from 'react-router-dom';
import SectionHeading from './SectionHeading';
import { Spinner } from 'react-bootstrap';
import { SEARCH_INDEX } from 'containers/profile_customer/MyWardrobe/constant';
import config from 'config';
import { SEARCH_WARDROBE } from 'graph_ql/search/search_wardrobe';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { STRINGS } from '../../../constants';

export const WardrobeSection = () => {
    const history = useHistory();
    const algoliaPrefix = config.algolia.algolia_prefix;
    const me = useSelector((state: RootState) => state.userDetail.me);
    const [wardobeItems, setWardobeItems] = useState<any[]>([]);

    const setItemsFromHits = (hits, searchVariables) => {
        if (searchVariables.index === algoliaPrefix + SEARCH_INDEX.ITEMS) {
            setWardobeItems(wardobeItems.concat(hits));
        } else {
            const result: any = [];
            for (const hit of hits) {
                const item = hit.extendsProps.itemData;
                if (item && item.length && item[0]) {
                    result.push(item[0]);
                }
            }
            setWardobeItems(wardobeItems.concat(result));
        }
    };
    const searchUploadedVariables = useMemo(() => {
        let filters = '';
        const index = algoliaPrefix + SEARCH_INDEX.ITEMS;
        const createdBy = me?.id;
        filters += createdBy ? `creator:"${createdBy}"` : '';
        const searchVariables = {
            index,
            query: '',
            filters: filters,
            hit: config.algoliaHitPerPage,
            page: 0,
            facets: ['title', 'tags.name', 'sizes.title'],
        };

        return searchVariables;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [me?.id]);

    const { loading: uploadedItemsLoading } = useQuery(SEARCH_WARDROBE, {
        variables: searchUploadedVariables,
        onCompleted(response) {
            const { hits } = response.items;
            setItemsFromHits(hits, searchUploadedVariables);
        },
        fetchPolicy: 'no-cache',
    });

    const renderSlider = () => {
        return (
            <Box className="d-flex w-100 overflow-scroll" style={{ paddingLeft: 14 }}>
                {wardobeItems.map((item, index) => {
                    return (
                        <div
                            className={styles.cardItem}
                            onClick={() => {
                                history.push(`${PATH.ITEM_DETAIL}/${item?.taffiId}`);
                            }}
                            key={index}
                        >
                            <img
                                alt="wardrobe-item"
                                src={item?.images.length > 0 ? item?.images[0] : ''}
                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }}
                            />
                        </div>
                    );
                })}
            </Box>
        );
    };

    const renderNoItemPanel = () => {
        return (
            <Box className={styles.sectionEmptyContainer}>
                {/* <Box className={styles.sectionEmptyLabel}>Your wardrobe is empty !</Box> */}
                <Box className={styles.sectionEmptyLabel} textAlign={'center'} margin={'8px 12px'}>
                    {STRINGS.WARDROBE_EMPTY_LABEL}
                </Box>
                <Box
                    className={styles.sectionEmptyButton}
                    onClick={() => {
                        history.push(`${PATH.WARDROBE}`);
                    }}
                >
                    UPLOAD ITEMS
                </Box>
            </Box>
        );
    };

    return (
        <Box className={styles.sectionContainer}>
            <SectionHeading
                title="Wardrobe"
                onClick={() => {
                    history.push(PATH.WARDROBE);
                }}
            />
            {uploadedItemsLoading ? (
                <div className="d-flex justify-content-center">
                    <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                </div>
            ) : wardobeItems.length <= 0 ? (
                renderNoItemPanel()
            ) : (
                <>{renderSlider()}</>
            )}
        </Box>
    );
};
